const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const options = MONTHS.map((month) => ({ value: month, label: month }));

const getMonth = (index) => options[((index % 12) + 12) % 12];

const toAbsoluteMonth = (date) => date.getFullYear() * 12 + date.getMonth();

const monthRange = (start, end) => {
  const list = [];
  for (let i = start; i <= Math.min(end, start + 11); i++)
    list.push(getMonth(i));
  return list;
};

const customerBillMonth = (customerData, amount) => {
  const billingDate = new Date(customerData?.billingCycle);
  if (!customerData || Number.isNaN(billingDate.getTime())) return [];

  const { balance, monthlyFee, status } = customerData;
  const offset = customerData.customerBillingType === "postpaid" ? -1 : 0;

  const base = toAbsoluteMonth(billingDate) + offset;
  const currentMonth = toAbsoluteMonth(new Date()) + offset;

  if (!(monthlyFee > 0)) return [getMonth(base)];

  if (balance < 0) {
    const dueMonths = Math.min(Math.ceil(Math.abs(balance) / monthlyFee), 11);
    const start = base - dueMonths;

    if (status === "active" || status === "expired") {
      const list = monthRange(start, base);

      if (amount < monthlyFee) list.pop();
      return list;
    }

    if (status === "inactive")
      return monthRange(start, Math.max(base, currentMonth));

    return [];
  }

  if (balance >= monthlyFee)
    return [getMonth(base + Math.floor(balance / monthlyFee))];

  return [getMonth(base)];
};

export default customerBillMonth;
